import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { slug } from '../../utils/store';

export default function ProtectedRoute({ children }) {

    const token =
        localStorage.getItem(`userTkn-${slug}`) ||
        sessionStorage.getItem(`userTkn-${slug}`);

    if (!token) {
        return <Navigate to={`/auth`} />;
    }

    return children;
}
